import PinButton, { pinButtonTypes } from './PinButton'

export { pinButtonTypes }

export default PinButton
